import React, { PureComponent } from "react";
import classNames from "classnames";
import { string } from "prop-types";

import Heading from "../heading/heading";

import "./slider-option.scss";

class SliderOption extends PureComponent {
  onClick = () => {
    this.props.onClick({
      forLabel: this.props.forLabel,
      value: !this.props.active,
    });
  };
  render() {
    const { label, active, headingElement } = this.props;
    return (
      <div
        className={classNames("slider-option", {
          ["slider-option--active"]: active,
        })}
      >
        <div className="slider-option__inner slide-option-switch-section">
          <button type="button" onClick={this.onClick}>
            <span className="slider-option__track">
              <span className="slider-option__button" />
            </span>
          </button>
          <Heading copy={label} element={headingElement} />
        </div>
      </div>
    );
  }
}

SliderOption.propTypes = {
  headingElement: string,
};

SliderOption.defaultProps = {
  headingElement: "h3",
};

export default SliderOption;
